/**
 * Per-domain configuration for the AI Cortex multi-domain router.
 *
 * Each domain specifies its display label, theme color, backend
 * endpoints for LLM and RAG, and which tool set to use.
 *
 * @module gibbs/cortex/domainConfig
 */

/**
 * Domain configuration map.
 *
 * @type {Object<string, {
 *   label: string,
 *   color: string,
 *   llmEndpoint: string,
 *   ragEndpoint: string,
 *   tools: string
 * }>}
 */
export const DOMAIN_CONFIG = {
    discovery: {
        label: 'Discovery',
        color: '#009688',
        llmEndpoint: '/services/agents/command/',
        ragEndpoint: '/services/agents/retrieve/',
        tools: 'gibbs',
    },
    clinical: {
        label: 'Clinical',
        color: '#1976d2',
        llmEndpoint: '/services/agents/chat/',
        ragEndpoint: '/services/cortex/knowledge/',
        tools: 'general',
    },
    corporate: {
        label: 'Corporate',
        color: '#757575',
        llmEndpoint: '/services/agents/chat/',
        ragEndpoint: '/services/cortex/knowledge/',
        tools: 'general',
    },
};

/**
 * Return the config object for a given domain key.
 *
 * @param {string} domain - 'discovery' | 'clinical' | 'corporate'
 * @returns {Object} Domain config (falls back to discovery)
 */
export function getDomainConfig(domain) {
    return DOMAIN_CONFIG[domain] || DOMAIN_CONFIG.discovery;
}
